module.exports = __webpack_public_path__ + "img/raio.bb7180aa.svg";